<form id="adicionarCargoForm" autocomplete="off" [formGroup]="adicionarCargoForm" (ngSubmit)="salvar()">
  <div class="row row-cols-3">


    <div class="col form-group my-2">
      <label for="idCargoReferencia" class="form-label required">Cargo Referência</label>
          <nz-select
            formControlName="idCargoReferencia"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Cargo Referência"
            nzSize="large"
            [compareWith]="compareFn"

          >
            <nz-option [nzValue]="item" [nzLabel]="item.nomeCargoReferencia" *ngFor="let item of cargoReferenciaList" />
          </nz-select>
    </div>
    <div class="col form-group my-2">
      <label for="nivelHierarquico" class="form-label required">Nível hierárquico</label>
          <nz-input-number nzSize="large"
            id="nivelHierarquico"
            formControlName="nivelHierarquico"
            [nzMin]="1"
            [nzStep]="1"
            nzPlaceHolder="Nível Hierarquico"
          ></nz-input-number>
          <ng-template #nomeTemplate>
            <span class="fs-5 me-2 clarity--user-solid"></span>
          </ng-template>

    </div>
  </div>
</form>
<div class="row mt-2">
  <div class="col-12 d-flex justify-content-end">
    <button nz-button nzType="default" class="me-3" (click)="reset()">Cancelar</button>
    <button nz-button nzType="primary" type="submit" form="adicionarCargoForm">{{ inserir ? 'Adicionar' : 'Editar' }}</button>
  </div>
</div>
